import { rankingMovies } from '@/mocks/homeData';

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line',
  steady: 'ri-subtract-line',
  down: 'ri-arrow-down-line',
  new: 'ri-sparkling-line',
};
const trendColors: Record<string, string> = {
  up: 'text-primary-500',
  steady: 'text-foreground-400',
  down: 'text-foreground-300',
  new: 'text-accent-500',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">热播榜单</h2>
            <p className="text-sm text-foreground-500 mt-2">本周最受影迷欢迎的电影排行</p>
          </div>
          <a href="#" className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
            查看完整榜单 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {rankingMovies.slice(0, 3).map((movie, i) => (
            <div key={movie.rank} className={`relative bg-background-100 rounded-xl p-5 flex items-start gap-4 group cursor-pointer transition-all hover:bg-background-200 ${i === 0 ? 'lg:col-span-2 lg:row-span-2' : ''}`}>
              {i === 0 ? (
                <>
                  <div className="shrink-0 w-[140px] h-[190px] rounded-lg overflow-hidden bg-background-300">
                    <img src={rankingMovies[0].imageUrl} alt={rankingMovies[0].title} className="w-full h-full object-cover" onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-white text-sm font-bold">{movie.rank}</span>
                      <span className="px-2 py-0.5 rounded-full bg-primary-500/10 text-primary-600 text-xs font-medium">{movie.hotLabel}</span>
                    </div>
                    <h3 className="font-heading text-lg font-bold text-foreground-900 mt-2">{movie.title}</h3>
                    <p className="text-xs text-foreground-500 mt-0.5">{movie.enTitle}</p>
                    <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                      <span>{movie.year}</span>
                      <span>·</span>
                      <span>{movie.genre}</span>
                    </div>
                    <div className="flex items-center gap-1 mt-3">
                      <i className="ri-star-fill text-accent-500 text-sm"></i>
                      <span className="text-sm font-bold text-foreground-800">{movie.rating}</span>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="shrink-0 w-[80px] h-[110px] rounded-lg overflow-hidden bg-background-300">
                    <img src={movie.imageUrl} alt={movie.title} className="w-full h-full object-cover" onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="w-7 h-7 flex items-center justify-center rounded-full bg-foreground-100 text-foreground-600 text-xs font-bold">{movie.rank}</span>
                      <span className={`text-xs ${trendColors[movie.trend]}`}><i className={trendIcons[movie.trend]}></i></span>
                    </div>
                    <h3 className="font-heading text-sm font-bold text-foreground-900 mt-1.5">{movie.title}</h3>
                    <p className="text-xs text-foreground-500 mt-0.5">{movie.genre}</p>
                    <div className="flex items-center gap-1 mt-1.5">
                      <i className="ri-star-fill text-accent-500 text-xs"></i>
                      <span className="text-xs font-bold text-foreground-700">{movie.rating}</span>
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
          {rankingMovies.slice(3).map((movie) => (
            <div key={movie.rank} className="bg-background-100 rounded-xl p-5 flex items-start gap-4 group cursor-pointer transition-all hover:bg-background-200">
              <div className="shrink-0 w-[80px] h-[110px] rounded-lg overflow-hidden bg-background-300">
                <img src={movie.imageUrl} alt={movie.title} className="w-full h-full object-cover" onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="w-7 h-7 flex items-center justify-center rounded-full bg-foreground-100 text-foreground-600 text-xs font-bold">{movie.rank}</span>
                  <span className={`text-xs ${trendColors[movie.trend]}`}><i className={trendIcons[movie.trend]}></i></span>
                </div>
                <h3 className="font-heading text-sm font-bold text-foreground-900 mt-1.5">{movie.title}</h3>
                <p className="text-xs text-foreground-500 mt-0.5">{movie.genre}</p>
                <div className="flex items-center gap-1 mt-1.5">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <span className="text-xs font-bold text-foreground-700">{movie.rating}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}